import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function ThankYou() {

  // Scroll to top quando carica la pagina
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="thank-you-wrapper">
      
      <div className="success-icon">
        <svg viewBox="0 0 24 24" className="checkmark">
          <path fill="none" stroke="#06D4E0" strokeWidth="2" d="M5 12l5 5L20 7" />
        </svg>
      </div>

      <h1>Messaggio Ricevuto!</h1>
      
      <p className="subtitle">
        Grazie per avermi contattato.<br />
        Riceverai la risposta direttamente via mail al più presto.
      </p>

      <div className="cta-group">
        <Link to="/" className="btn-primary">Torna alla Home</Link>
      </div>

    </div>
  );
}

export default ThankYou;